import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { LanguageProvider, useLanguage } from "./LanguageContext";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const CreateAccount = React.lazy(() => import("./Pages/CreateAccount/CreateAccount"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/Dashboard"));
const FormDashboard = React.lazy(() => import("./Pages/MentalHealthConnectionForm/FormDashboard"));
const MentalHealthConnectionForm = React.lazy(() => import("./Pages/MentalHealthConnectionForm/Step1"));
const ProfilePage = React.lazy(() => import("./Pages/ProfilePage/ProfilePage"));
const LinksPage = React.lazy(() => import("./Pages/LinksPage/LinksPage"));
const NewsPage = React.lazy(() => import("./Pages/NewsPage/NewsPage"));
const CheckoutContainer = React.lazy(() => import("./Pages/CreateAccount/Components/stripePayments"));

import App from "./App";
const LoginPage = React.lazy(() => import("./Pages/LoginPage/LoginPage"));
// import LoginPage from "./Pages/LoginPage/LoginPage";

function LoadingFallback() {
  const { t } = useLanguage();
  return <div>{t("Loading...")}</div>;
}

function NotFoundPage() {
  const { t } = useLanguage();
  return <h1>{t("Not Found")}</h1>;
}

// Check if the root element exists
const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error(
    "Root element not found! Make sure you have a <div id='root'></div> in your HTML."
  );
  throw new Error("Root element not found!");
}

console.log("Root element found, creating React root...");

// Create React root and render the application
try {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <LanguageProvider>
      <Suspense fallback={<LoadingFallback />}>
        <Router
          future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
          onUpdate={() => window.scrollTo(0, 0)}
        >
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/CreateAccount" element={<CreateAccount />} />
            <Route path="/loginPage" element={<LoginPage />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/FormDashboard" element={<FormDashboard />} />
            <Route
              path="/mentalHealthConnectionForm"
              element={<MentalHealthConnectionForm />}
            />
            <Route path="/profilePage" element={<ProfilePage />} />
            <Route path="/linksPage" element={<LinksPage />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/NewsPage" element={<NewsPage />} />
            <Route path="/BillingPage" element={<CheckoutContainer />} />
          </Routes>
        </Router>
      </Suspense>
    </LanguageProvider>
  );

  console.log("React application rendered successfully!");
} catch (error) {
  console.error("Error creating React root:", error);

  // Fallback for older React versions
  try {
    console.log("Trying fallback render method...");
    ReactDOM.render(
      <React.StrictMode>
        <LanguageProvider>
          <Suspense fallback={<LoadingFallback />}>
            <Router
              future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
              onUpdate={() => window.scrollTo(0, 0)}
            >
              <Routes>
                <Route path="/" element={<App />} />
                <Route path="/CreateAccount" element={<CreateAccount />} />
                <Route path="/loginPage" element={<LoginPage />} />
                <Route path="/Dashboard" element={<Dashboard />} />
                <Route path="/FormDashboard" element={<FormDashboard />} />
                <Route
                  path="/mentalHealthConnectionForm"
                  element={<MentalHealthConnectionForm />}
                />
                <Route path="/profilePage" element={<ProfilePage />} />
                <Route path="/linksPage" element={<LinksPage />} />
                <Route path="*" element={<NotFoundPage />} />
                <Route path="/NewsPage" element={<NewsPage />} />
                <Route path="/BillingPage" element={<CheckoutContainer />} />
              </Routes>
            </Router>
          </Suspense>
        </LanguageProvider>
      </React.StrictMode>,
      rootElement
    );
    console.log("Fallback render successful!");
  } catch (fallbackError) {
    console.error("Both createRoot and fallback render failed:", fallbackError);
  }
}
